import { Avatar, Box, Tooltip, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { DeleteConfirmationDialog } from '../../../shared/components/SconApp/deleteConfirmation/DeleteConfirmationDialog';
import { List } from '../../../shared/components/SconApp/list/List';
import { useUserContext } from '../../../shared/contexts';
import { feedback } from '../../../shared/services/alertService';
import { IPropsBusinessPage } from '../Business';
import { SconIcon } from '../../../shared/assets';
import { businessAdminService } from '../../../shared/services/api/businessAdminService';

export const BusinessAdmins: React.FC<IPropsBusinessPage> = ({ business, refetch }) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [id, setId] = useState<number>();

  const { userId } = useUserContext();

  const handleClose = useCallback(() => {
    setOpenDeleteDialog(false);
    setId(undefined);
  }, []);

  const onClickDelete = useCallback((id: number) => {
    setOpenDeleteDialog(true);
    setId(id);
  }, []);

  const { mutate: remove, isLoading: isLoadingDelete } = useMutation((id: number) =>
    businessAdminService.remove(id), {
    onSuccess: () => {
      refetch();
      handleClose();
    },
    onError: (error: Error) => feedback(error.message, 'error'),
  });

  const onClickConfirmDelete = useCallback(() => {
    id && remove(id);
  }, [id]);

  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={3}
      padding={3}
    >
      <Typography variant="body2" color="textSecondary">
        Para adicionar novos administradores, edite um profissional e clique no botão &quot;Tornar administrador&quot;.
      </Typography>

      <List
        list={
          business.admins!.map((item) => ({
            id: item.id,
            description: item.user.name + (item.userId == userId ? ' (Você)' : ''),
            endAdornment: (
              <Tooltip title='É um usuário SconApp'>
                <img
                  src={SconIcon}
                  alt='logo'
                  height={30}
                  width={30}
                />
              </Tooltip>
            ),
            startAdornment: (
              <Avatar src={item.user.profilePicture} slotProps={{ img: { loading: 'lazy' } }}>{item.user.name.substring(0, 1)}</Avatar>
            ),
            disabled: item.userId == userId
          }))}
        onClickDelete={onClickDelete}
      />

      <DeleteConfirmationDialog
        onClose={handleClose}
        onConfirm={onClickConfirmDelete}
        open={openDeleteDialog}
        isLoading={isLoadingDelete}
        label='Tem certeza que deseja deletar este administrador?'
      />
    </Box>
  );
};